export const popularSearches = [
  "Product manager with zero to one experience on payroll systems",
  "Full stack developer with experience training LLMs with ML for an AI application",
  "Product designer who can prototype animations on mobile",
];
